import React, { useState } from "react";
import { useAuth } from "../../Hooks/Auth";
import { useNavigate } from "react-router-dom";
import { ChangeCollaboratorPasswordUseCase } from "../../Usecase/Collaborators/change-collaborator-password-usecas";
import { CollaboratorsApiRemoteService } from "../../Services/api/collaborators/collaborators-service";
import api from "../../Services/api";
import { useToast } from "../../Hooks/ToasContext";
import { UserProps } from "../../Hooks/Auth";

export function useAccountMenu() {
    const { signOut, user, updateUser } = useAuth();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [openDialog, setOpenDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();

    const changeCollaboratorPasswordUseCase = new ChangeCollaboratorPasswordUseCase(
      new CollaboratorsApiRemoteService(api),
    );

    const handleChangePassword = async (data: { password: string }) => {
        if (!user) {
          return;
        }

        setLoading(true);
        try {
            await changeCollaboratorPasswordUseCase.handle(data.password);
            setOpenDialog(false);
            updateUser({ ...user, resetPassword: false } as UserProps);
            showToast('Senha alterada com sucesso', 'success');
            navigate('/dashboard');
        } catch (error) {
            console.error(error);
            showToast('Não foi possível alterar a senha. Tente novamente.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleLogout = async () => {
      signOut();
    };

    return {
        openDialog,
        setOpenDialog,
        loading,
        handleClick,
        handleClose,
        handleLogout,
        open,
        anchorEl,
        handleChangePassword,
    };
}
